import React from 'react'
import '../../pages/quotation/Quotation.scss';
import { NotFound } from '../../components/common/NotFound';
import PaginationComponent from '../common/PaginationComponent';
import QuotationProjectRowSkeleton from './QuotationProjectRowSkeleton';
import QuotationWorklistHeader from './QuotationWorklistHeader';
import QuotationWorklistRow from './QuotationWorklistRow';

const QuotationGrid = (props) => {
    const { menuRights, navigateToQuotationGeneral, quotation, loading, filterData, setPageNumber, setPageSize, pageSize } = props;

    return (<>
        {quotation?.payload?.length > 0 ?
            <div className="row table-row row-height mb-3">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <QuotationWorklistHeader />
                    {quotation?.payload.map((item, index) => (
                        <QuotationWorklistRow
                            key={[
                                item?.projectId,
                                item?.projectReference,
                                item?.distributorName,
                                item?.countryName,
                                index,
                            ].filter(Boolean).join("-")}
                            item={item}
                            rowIndex={index}
                            navigateToQuotationGeneral={navigateToQuotationGeneral}
                        />
                    ))}
                </div>
            </div>
            : loading === true ? (
                <div className="row table-row row-height mb-3">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <QuotationWorklistHeader />
                        {Array.from({ length: 10 }).map((_, index) => (
                            <QuotationProjectRowSkeleton key={index} rowIndex={index} />
                        ))}
                    </div>
                </div>
            ) : <NotFound />}

        {quotation?.totalRecords > 0 && (
            <PaginationComponent
                moduleName="Quotation"
                count={pageSize}
                setCount={setPageSize}
                pageSize={filterData?.PageSize}
                currentPage={filterData?.PageNumber}
                filteredResults={quotation}
                setCurrentPage={setPageNumber} />)}
    </>
    )
}

export default React.memo(QuotationGrid)
